import moment from 'moment'
import React, { Fragment, useState } from 'react'
import {
  FieldWrapper,
  Label,
  RemoveButton,
  Select
} from '../ContentStructure/Components'
import { LeftChevron } from 'images'
import Collapse from 'ui/bend/animations/Collapse'
import ReportUserTable from './ReportUserTable'
import { Switch } from 'ui/bend'

const ReportsTable = ({
  data = [],
  handleDelete = () => {},
  sortConfig = {},
  setSortConfig = () => {}
}) => {
  const [openSections, setOpenSections] = useState({})

  const deleteClick = ({
    content_type = '',
    reply_id = '',
    comment_id = '',
    type = '',
    content_id = ''
  }) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete this ${type.toLowerCase()}`
    )

    confirmed &&
      handleDelete({ content_type, reply_id, comment_id, content_id })
  }

  return (
    <>
      <div className='absolute'>
        <FieldWrapper className='select-sort'>
          <Label>Sort</Label>
          <Select
            value={sortConfig?.sortKey || 'newest'}
            onChange={(e) => {
              const sortKey = e.target.value
              setSortConfig((state) => ({
                ...state,
                sortKey,
                loadMore: false
              }))
            }}
          >
            <option value='newest'>Newest</option>
            <option value='oldest'>Oldest</option>
            <option value='top'>Most Reported</option>
          </Select>
        </FieldWrapper>
        <div className='flex-box'>
          <Switch
            label='Active'
            name='active'
            checked={sortConfig?.deleted || false}
            onChange={(e) => {
              setSortConfig((state) => ({
                ...state,
                loadMore: false,
                deleted: !Boolean(state?.deleted)
              }))
            }}
          />
          <p>DELETED</p>
        </div>
      </div>
      <table className='table table-bordered table-striped'>
        <thead className='table-light'>
          <tr>
            <th role='button'>Type</th>
            <th className='text'>Text</th>
            <th role='button'>Reports</th>
            <th role='button'>Posted By</th>
            <th role='button'>Posted On</th>
            <th role='button'>Last Reported</th>
            {!sortConfig.deleted && <th>Manage</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <Fragment key={row.id}>
              <tr key={row.id}>
                <td>{row.type}</td>
                <td>{row.text}</td>
                <td>
                  <div className='flex-box'>
                    <p>{row.reports}</p>
                    <RemoveButton
                      onClick={() =>
                        setOpenSections((state) => ({
                          ...state,
                          [row.id]: !Boolean(state[row.id])
                        }))
                      }
                      className={`collapse-button ${
                        openSections[row.id] ? 'opened' : 'closed'
                      }`}
                    >
                      <LeftChevron />
                    </RemoveButton>
                  </div>
                </td>
                <td>{row.fullName}</td>
                <td className='td-date'>
                  {moment(row.postedAt).local().format('MM/DD/YYYY HH:mm')}
                </td>
                <td className='td-date'>
                  {moment(row.reportedAt).local().format('MM/DD/YYYY HH:mm')}
                </td>
                {!sortConfig.deleted && (
                  <td>
                    <a
                      onClick={() => deleteClick(row)}
                      className='blue'
                      role='button'
                    >
                      DELETE
                    </a>
                  </td>
                )}
              </tr>

              <tr>
                <td
                  className={`p-0 ${openSections[row.id] ? 'open' : ''}`}
                  colSpan={7}
                >
                  <Collapse isOpened={openSections[row.id] || false}>
                    {openSections[row.id] && (
                      <ReportUserTable pk={row.pk} sk={row.sk} />
                    )}
                  </Collapse>
                </td>
              </tr>
            </Fragment>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default ReportsTable
